import { Schema } from "effect";

/**
 * Station-level source authority. Absent/`legacy` means Workerspace storage is
 * authoritative. `repository` means StationRepository owns source after the
 * first-Change migration linearization CAS. `reversal-draining` is reserved for
 * the repository→legacy drain protocol.
 */
export const StationSourceAuthority = /* @__PURE__ */ (() => Schema.Literals(["legacy", "repository", "reversal-draining"]))();
export type StationSourceAuthority = typeof StationSourceAuthority.Type;

/**
 * A workerstation is what the URL identifies: an ordered collection of workerspaces
 * plus which one is active. Sharing the URL shares the whole rail.
 */
export const WorkerstationState = /* @__PURE__ */ (() => Schema.Struct({
  workspaces: Schema.Array(Schema.String).pipe(Schema.mutable).pipe(Schema.mutableKey),
  active: Schema.String.pipe(Schema.optional, Schema.mutableKey),
  createdAt: Schema.Number.pipe(Schema.mutableKey),
  updatedAt: Schema.Number.pipe(Schema.mutableKey),
  /** Defaults to legacy when omitted for pre-migration stations. */
  sourceAuthority: StationSourceAuthority.pipe(Schema.optional, Schema.mutableKey),
  /** Active repository ref name after cutover; normally `main`. */
  repositoryMainRef: Schema.String.pipe(Schema.optional, Schema.mutableKey),
}))();
export type WorkerstationState = typeof WorkerstationState.Type;

export const WorkerspaceMeta = /* @__PURE__ */ (() => Schema.Struct({
  openTabs: Schema.Array(Schema.String).pipe(Schema.mutable).pipe(Schema.mutableKey),
  currentFile: Schema.Union([Schema.String, Schema.Null]).pipe(Schema.optional, Schema.mutableKey),
  options: Schema.Struct({
  bundle: Schema.Boolean.pipe(Schema.optional, Schema.mutableKey),
  minify: Schema.Boolean.pipe(Schema.optional, Schema.mutableKey),
}).pipe(Schema.optional, Schema.mutableKey),
  folders: Schema.Array(Schema.String).pipe(Schema.mutable).pipe(Schema.optional, Schema.mutableKey),
  createdAt: Schema.Number.pipe(Schema.mutableKey),
  updatedAt: Schema.Number.pipe(Schema.mutableKey),
}))();
export type WorkerspaceMeta = typeof WorkerspaceMeta.Type;

export const WorkerspaceState = /* @__PURE__ */ (() => Schema.Struct({
  ...WorkerspaceMeta.fields,
  files: Schema.Record(Schema.String, Schema.mutableKey(Schema.String)).pipe(Schema.mutableKey),
}))();
export type WorkerspaceState = typeof WorkerspaceState.Type;

export const WorkerstationInput = /* @__PURE__ */ (() => Schema.Struct({
  workspaces: Schema.Array(Schema.String).pipe(Schema.mutable).pipe(Schema.mutableKey),
  active: Schema.String.pipe(Schema.optional, Schema.mutableKey),
  sourceAuthority: StationSourceAuthority.pipe(Schema.optional, Schema.mutableKey),
  repositoryMainRef: Schema.String.pipe(Schema.optional, Schema.mutableKey),
}))();
export type WorkerstationInput = typeof WorkerstationInput.Type;
